'use client';

import { c as _c } from "react/compiler-runtime";
import { Picture } from '@petsmart-ui/sparky';
import { A11y, FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { trackContentfulClick } from '@libs/analytics';
import { BREAKPOINTS } from '@libs/common-next';
import { COLOR_TABLE } from '../../constants';
import type { Link } from '../../types';
import { calculateBreakpointConfiguration } from './Tile6UpCampaign.utils';
import type { Tile6UpProps, TilesProps } from './types';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import './Tile6UpCampaign.scss';
type CampaignTileProps = Omit<TilesProps, 'link'> & {
  link: Link;
};
export default function Tile6UpCampaign(t0) {
  const $ = _c(38);
  const {
    header,
    variant,
    tiles,
    pathname,
    textColor
  } = t0;
  let T0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== header || $[1] !== pathname || $[2] !== textColor || $[3] !== tiles || $[4] !== variant) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const campaignTiles = tiles.filter(_temp);
      if (campaignTiles.length === 0) {
        t10 = null;
        break bb0;
      }
      let t11;
      if ($[16] !== header || $[17] !== pathname || $[18] !== variant) {
        t11 = (title, index, link, internalTitle) => () => {
          trackContentfulClick({
            position: index + 1,
            linkText: title,
            linkUrl: link,
            promoTitle: header ?? "",
            promoVariant: `tile 6up - ${variant.toLowerCase()}`,
            promoOrigin: pathname,
            promoDesc: internalTitle,
            promoType: `tile-6up-${variant.toLowerCase()}`
          });
        };
        $[16] = header;
        $[17] = pathname;
        $[18] = variant;
        $[19] = t11;
      } else {
        t11 = $[19];
      }
      const handleTileClick = t11;
      t9 = "tile6up-campaign-wrapper";
      T0 = Swiper;
      t1 = 32;
      t2 = "auto";
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [FreeMode, Navigation, A11y];
        $[20] = t3;
      } else {
        t3 = $[20];
      }
      t4 = true;
      t5 = calculateBreakpointConfiguration(campaignTiles.length);
      t6 = true;
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          enabled: true,
          scrollOnFocus: true
        };
        $[21] = t7;
      } else {
        t7 = $[21];
      }
      let t12;
      if ($[22] !== handleTileClick || $[23] !== textColor) {
        t12 = (tile_0, index_0) => <SwiperSlide key={tile_0.sysId || `${tile_0.title}-${index_0}-${tile_0.image?.remoteDesktopImageUrl || ""}`} className="tile6up-campaign-slide"><a className="sparky-c-text-link sparky-c-tile six-tile-item" href={tile_0.link.webUrl} onClick={handleTileClick(tile_0.title, index_0, tile_0.link.webUrl, tile_0.internalTitle || "")} data-testid="six-tile-carousel-tile"><Picture imgSrc={tile_0.image.remoteDesktopImageUrl} imgAlt={tile_0.image.webAltText} items={[{
              media: `(max-width: ${BREAKPOINTS.md}px)`,
              srcSet: tile_0.image.remoteMobileImageUrl ?? tile_0.image.remoteDesktopImageUrl
            }, {
              media: `(min-width: ${BREAKPOINTS.md}px)`,
              srcSet: tile_0.image.remoteDesktopImageUrl
            }]} /><span className="sparky-c-tile__title" style={{
              color: textColor ? COLOR_TABLE[textColor] : undefined
            }}>{tile_0.title}</span></a></SwiperSlide>;
        $[22] = handleTileClick;
        $[23] = textColor;
        $[24] = t12;
      } else {
        t12 = $[24];
      }
      t8 = campaignTiles.map(t12);
    }
    $[0] = header;
    $[1] = pathname;
    $[2] = textColor;
    $[3] = tiles;
    $[4] = variant;
    $[5] = T0;
    $[6] = t1;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[5];
    t1 = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[25] !== T0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
    t11 = <T0 spaceBetween={t1} slidesPerView={t2} modules={t3} freeMode={t4} breakpoints={t5} navigation={t6} a11y={t7}>{t8}</T0>;
    $[25] = T0;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t9) {
    t12 = <div className={t9}>{t11}</div>;
    $[35] = t11;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
}
function _temp(tile) {
  return Boolean(tile.link?.webUrl);
}